import { jsxs as m, jsx as e } from "@emotion/react/jsx-runtime";
import i from "prop-types";
import { css as t } from "@emotion/react";
import { COLORS as o } from "../../../constants.mjs";
import { Text as l } from "../../Typography/Typography.mjs";
import { makeStyles as p } from "../../../theme.mjs";
import { Info as d } from "../../Icon/Info.mjs";
import { Check as a } from "../../Icon/Check.mjs";
import { Alert as E } from "../../Icon/Alert.mjs";
const C = {
  INFO: "info",
  SUCCESS: "success",
  ERROR: "error"
}, O = {
  info: /* @__PURE__ */ e(d, {}),
  success: /* @__PURE__ */ e(a, {}),
  error: /* @__PURE__ */ e(E, {})
}, S = {
  info: o.COMPLEMENTARY_YELLOW,
  success: o.COMPLEMENTARY_CYAN,
  error: o.COMPLEMENTARY_ORANGE
}, Y = p((n, r) => ({
  container: t`
        background: ${S[r]};
        padding: 1rem;
        display: flex;
        color: ${o.BLACK};
    `,
  icon: t`
        padding-right: 1rem;
        display: flex;
        & > svg {
            fill: ${o.BLACK};
        }
    `,
  text: t`
        align-self: center;
        color: ${o.BLACK};

        a {
            color: ${o.BLACK};
            text-decoration: underline;
        }
    `
})), c = ({ message: n, type: r, ...f }) => {
  const s = Y(r);
  return /* @__PURE__ */ m("div", { css: s.container, ...f, children: [
    /* @__PURE__ */ m("div", { css: s.icon, children: [
      " ",
      O[r],
      " "
    ] }),
    /* @__PURE__ */ e(l, { css: s.text, size: l.SIZES.S, children: n })
  ] });
};
c.TYPES = C;
c.propTypes = {
  type: i.oneOf(Object.values(c.TYPES)).isRequired,
  /** User friendly message */
  message: i.node.isRequired,
  className: i.string
};
export {
  c as Notification,
  C as TYPES
};
